import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import { ModalContainer, ModalDialog } from 'react-modal-dialog';
import { browserHistory } from 'react-router';
// Components
import CloseButton from '../../layout/closeButton/CloseButton';
import LoadingContent from '../../layout/loadingContent/LoadingContent';


const propTypes = {
  loading: PropTypes.bool.isRequired,
  exhibitorDetails: PropTypes.object.isRequired,
};

const ExhibitorDetails = (props) => {
  if (props.loading) {
    return LoadingContent;
  }

  const {
    tradeName,
    companyName,
    booth,
    resume,
    street,
    number,
    complement,
    city,
    state,
    country,
    phone,
    fax,
    email,
    mainExecutive,
    marketingExecutive,
    site,
  } = props.exhibitorDetails;

  const handleClose = () => {
    browserHistory.goBack();
  };

  return (
    <ModalContainer onClose={handleClose}>
      <ModalDialog onClose={handleClose}>
        <div className="ui text container">
          <div>
            <div>
              <div className="ui top attached segment">
                <h3 className="ui header">
                  {tradeName}
                  <div className="sub header">{companyName}</div>
                </h3>
                {
                  booth &&
                    <div className="ui top right attached label">
                      <FormattedMessage
                        id="booth"
                        description="Booth number"
                        default="Booth number"
                        values={{ booth }}
                      />
                    </div>
                }
              </div>
              {
                resume &&
                  <div className="ui middle attached segment">
                    {
                      resume.split('\n').map((line, i) => {
                        return <span key={i}>{line}<br /></span>;
                      })
                    }
                  </div>
              }
              <div className="ui bottom attached segment">
                <h4 className="ui header">Extra:</h4>
                <div className="ui list">
                  {
                    (street || number || complement || city || state || country) &&
                      <div className="item">
                        <i className="building outline blue icon" />
                        <div className="content">
                          {street}{ number && <span>, {number}</span>}{ complement && <span>, {complement}</span>}
                          {city && <span>. {city}</span>}
                          {state && <span> - {state}</span>}
                          {country && <span> - {country}</span>}.
                        </div>
                      </div>
                  }
                  {
                    (phone || fax) &&
                      <div className="item">
                        <i className="call blue icon" />
                        <div className="content">
                          {phone}
                        </div>
                      </div>
                  }
                  {
                    email &&
                      <div className="item">
                        <i className="mail outline blue icon" />
                        <div className="content">
                          <a href={`mailto:${email}`}>{email}</a>
                        </div>
                      </div>
                  }
                  {
                    mainExecutive &&
                      <div className="item">
                        <i className="user blue icon" />
                        <div className="content">
                          <FormattedMessage
                            id="mainExecutive"
                            description="Main executive tag"
                            defaultMessage="Main Executive: "
                          />
                          {mainExecutive}
                        </div>
                      </div>
                  }
                  {
                    marketingExecutive &&
                      <div className="item">
                        <i className="user blue icon" />
                        <div className="content">
                          <FormattedMessage
                            id="marketingExecutive"
                            description="Marketing executive tag"
                            defaultMessage="Marketing Executive: "
                          />
                          {marketingExecutive}
                        </div>
                      </div>
                  }
                </div>
              </div>
            </div>
            <div className="ui hidden divider" />
            <CloseButton handleClose={handleClose} />
          </div>
        </div>
      </ModalDialog>
    </ModalContainer>
  );
};

ExhibitorDetails.propTypes = propTypes;

export default ExhibitorDetails;



/** WEBPACK FOOTER **
 ** ./src/components/screens/exhibitors/ExhibitorDetails.js
 **/